import 'bootstrap/dist/css/bootstrap.min.css';
import { Card } from "react-bootstrap";
import { Form, Button, Container, Row, Col, Spinner } from 'react-bootstrap';
import { useLanguage } from "../LanguageContext"; // Provides translations
import { useForm, ValidationError } from '@formspree/react'; // Import Formspree
import '../styles/SectionCard.css';
import '../styles/contact.css';
import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha"; // Import Google reCAPTCHA
import { FaInstagram, FaYoutube } from 'react-icons/fa';

const Contact = () => {
    const { translations } = useLanguage();
    const [state, handleSubmit] = useForm("mqapedzg"); // Replace with your Formspree Form ID
    const [recaptchaToken, setRecaptchaToken] = useState(null);

    // Handle reCAPTCHA success
    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    return (
        <Card className="section-card">
            <Card.Body>
                <h1>{translations.contact.title}</h1>
                <Card.Text>
                    <Container className="mt-8">
                        <Row className="justify-content-center">
                            <h2>Contact Us</h2>

                            {/* Success Message */}
                            {state.succeeded ? (
                                <div className="text-center">
                                    <h4>Thank you for reaching out!</h4>
                                    <p>We'll get back to you as soon as possible.</p>
                                </div>
                            ) : (
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="formName">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter your name"
                                            name="name"
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formEmail">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email"
                                            name="email"
                                            required
                                        />
                                        <ValidationError prefix="Email" field="email" errors={state.errors} />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formMessage">
                                        <Form.Label>Message</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder="Type your message here"
                                            name="message"
                                            required
                                        />
                                        <ValidationError prefix="Message" field="message" errors={state.errors} />
                                    </Form.Group>

                                    {/* Google reCAPTCHA */}
                                    <Form.Group className="mb-3 d-flex recaptcha-container" >
                                        <ReCAPTCHA
                                            sitekey="6Lcr1PkqAAAAAKI5eErIPLz--XUDlZGetBuQeK2o" // Replace with your real Google reCAPTCHA v2 Site Key
                                            onChange={handleRecaptchaChange}
                                        />
                                    </Form.Group>

                                    <Button variant="primary" type="submit" disabled={state.submitting || !recaptchaToken} className="w-100">
                                        {state.submitting ? <Spinner animation="border" size="sm" /> : "Send"}
                                    </Button>
                                </Form>
                            )}
                        </Row>

                        <Row className="justify-content-center mt-3">
                            <Col xs="auto">
                                <a href="mailto:office@pdbf-records.com" className="text-white text-decoration-none">
                                    📧 office@pdbf-records.com
                                </a>
                            </Col>
                        </Row>

                        {/* Social Media Row */}
                        <Row className="justify-content-center mt-3">
                            <Col xs="auto">
                                <a href="https://www.instagram.com/pdbf_records?igsh=MW9hdGxobTYyMXZ6Zw==" target="_blank" rel="noopener noreferrer" className="mx-2 text-white">
                                    <FaInstagram size={24} />
                                </a>
                                <a href="https://www.youtube.com/@pdbf_records" target="_blank" rel="noopener noreferrer" className="mx-2 text-white">
                                    <FaYoutube size={24} />
                                </a>
                            </Col>
                        </Row>
                    </Container>
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

export default Contact;